import React from "react";
import { FileText, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { APP_NAME } from "@/constants/app";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-slate-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl p-6 sm:p-10 shadow-sm border border-slate-200">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-xs font-semibold text-sif-primary hover:underline mb-6"
        >
          <ArrowLeft className="w-4 h-4" /> Back to Funds
        </Link>

        <div className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-200">
          <div className="w-10 h-10 rounded-xl bg-sif-primary flex items-center justify-center text-white">
            <FileText className="w-6 h-6" />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
              Terms of Service
            </h1>
            <p className="text-xs text-slate-500 font-medium mt-1">
              Last updated: {new Date().toLocaleDateString("en-US", { month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>

        <div className="space-y-6 text-sm text-slate-700 leading-relaxed">
          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900">1. Acceptance of Terms</h2>
            <p>
              By accessing and using {APP_NAME}, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use the platform.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900">2. Investment Disclaimer & Risk Disclosure</h2>
            <p>
              Specialized Investment Funds (SIFs) and financial securities carry inherent market risks. All data, performance metrics, and content presented on this platform are for informational and educational purposes only and do not constitute financial advice.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900">3. Intellectual Property</h2>
            <p>
              All materials, including logos, designs, text, graphs, and software on this platform, are the property of {APP_NAME} or its content suppliers and are protected by applicable intellectual property laws.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900">4. Limitation of Liability</h2>
            <p>
              {APP_NAME} shall not be held liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use this platform or reliance on any metrics provided.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-slate-900">5. Governing Law</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of India.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
